// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2-L2E","checkboxCol":"Table_checkboxCol__1PIxo","emailCol":"Table_emailCol__1c4lj","actionCol":"Table_actionCol__2zSO4"};